(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .directive('sgInput', sgInput);

  sgInput.$inject = ['$compile'];

  function sgInput ($compile) {

    var getTemplate = function (type) {
      var tpl;
      switch (type.trim().toLowerCase()) {
        case 'longstring':
          tpl = '<textarea rows="1" id="{{sgId}}" ng-model="ngModel" ' +
            'ng-blur="ngBlur({value: ngModel})" ng-focus="ngFocus()" ' +
            'ng-disabled="ngDisabled" ng-class="ngClass" class="{{sgClass}}"></textarea>';
          break;

        case 'number':
          tpl = '<input type="number" id="{{sgId}}" ng-model="ngModel" ' +
            'ng-blur="ngBlur({value: ngModel})" ng-focus="ngFocus()" ' +
            'ng-disabled="ngDisabled" ng-class="ngClass" class="{{sgClass}}">';
          break;

        case 'string':
          tpl = '<input type="text" id="{{sgId}}" ng-model="ngModel" ' +
            'ng-blur="ngBlur({value: ngModel})" ng-focus="ngFocus()" ' +
            'ng-disabled="ngDisabled" ng-class="ngClass" class="{{sgClass}}">';
          break;

        case 'select':
          tpl = '<select ng-model="ngModel" id="{{sgId}}" ng-change="ngBlur({value: ngModel})" ' +
            'ng-focus="ngFocus()" ng-disabled="ngDisabled" ng-class="ngClass" class="{{sgClass}}" ' +
            '>' +
              '<option value="" ng-selected="ngModel === \'\'">--</option>' +
              '<option ' +
                'ng-repeat="option in input.selectOptions" ' +
                'value="{{option.id}}" ' +
                'ng-selected="ngModel === option.id">' +
                '{{option.name}}' +
              '</option>' +
            '</select>';
          break;

        case 'selecttemplate':
          tpl = '<select ng-model="ngModel" id="{{sgId}}" ng-change="ngBlur({value: ngModel})" ' +
            'ng-focus="ngFocus()" ng-disabled="ngDisabled" ng-class="ngClass" class="{{sgClass}}" ' +
            // You might wonder why sg-value is placed here: for some unexplainable, magical reason this forces
            // the ng-selected to be set correctly within the e2e-test environment.
            'sg-value="{{ngModel}}">' +
              '<option value="" ng-selected="ngModel === \'\'">--</option>' +
              '<option ' +
                'ng-repeat="option in input.selectOptions" ' +
                'value="{{option.id}}" ' +
                'ng-selected="ngModel === option.id">' +
                '{{option.name}}' +
              '</option>' +
            '</select>';
          break;

        default:
          tpl = '<div ng-show="!element" style="color:red;" ' +
            'value="{{value}}">geen geldig element meegegeven aan input.directive</div>';
      }

      return tpl;

    };

    return {
      restrict: 'E',
      scope: {
        ngModel: '=',
        ngDisabled: '=',
        ngClass: '=',
        ngFocus: '&sgFocus',
        ngBlur: '&sgBlur',
        sgClass: '@',
        sgId: '@',
        context: '@',
        input: '=',
        qualityLevel: '=',
      },
      link: function (scope, element) {
        let type = scope.input.inputType || scope.input.type;
        type = type.replace(' ', '');
        if (type.toLowerCase() === 'select') {
          type = scope.context === 'template' ? 'selectTemplate' : 'select';
          scope.input.selectOptions = scope.input.selectOptions.filter((option) => option.active);
        }
        let template = getTemplate(type);

        element.replaceWith($compile(template)(scope));
      }

    };

  }
})();
